import {ActionIcon, Flex, Text, Tooltip} from '@mantine/core'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../routes.ts'
import {useSubscription} from '../../providers/subscription/useSubscription.ts'
import {IconArrowUp} from '@tabler/icons-react'

type Props = {
  featureName: string
  disabled: boolean
}

export const FeatureNotAvailableButton = ({featureName, disabled: containerDisabled}: Props) => {
  const {activeSubscriptionTier} = useSubscription()
  const navigate = useNavigate()

  const disabled = containerDisabled || !activeSubscriptionTier.canUpgrade

  if (disabled) return null

  return (
    <Tooltip
      multiline
      maw={300}
      withArrow
      label={
        <Flex gap={5} direction={'column'}>
          <Text size={'xs'}>{featureName} is not available in your current subscription tier.</Text>
          <Text size={'xs'}>Click here to see your options and upgrade.</Text>
        </Flex>
      }
    >
      <ActionIcon
        size={'xs'}
        variant={'filled'}
        onMouseDown={(e) => {
          e.preventDefault()
          navigate(routes.subscriptions.root.buildRoute())
        }}
      >
        <IconArrowUp />
      </ActionIcon>
    </Tooltip>
  )
}
